import { PauseIcon, PlayIcon, ReplayIcon } from "../components/Icons";
import { useVideoPlayer2 } from "../hooks/use-video-player-2-setup-start";
import { useVideoPlayer2Play } from "../hooks/useVideoPlayer2Play";

export function PlayPauseButton() {
  const { isPlaying, isEnded, handlePlayPauseRewind } = useVideoPlayer2Play();
  const player = useVideoPlayer2();

  const getButtonTitle = () => {
    if (isEnded) {
      return player.trans("replay") || "Replay";
    }
    return isPlaying ? player.trans("pause") : player.trans("play");
  };

  const getButtonAriaLabel = () => {
    if (isEnded) {
      return player.trans("replay") || "Replay";
    }
    return isPlaying ? player.trans("pause") : player.trans("play");
  };

  const renderIcon = () => {
    if (isEnded) {
      return <ReplayIcon />;
    }
    return isPlaying ? <PauseIcon /> : <PlayIcon />;
  };

  return (
    <button
      className="video-player-2-btn"
      onClick={handlePlayPauseRewind}
      title={getButtonTitle()}
      aria-label={getButtonAriaLabel()}
    >
      {renderIcon()}
    </button>
  );
}
